import { SliderBuffer } from "../../../../../ui/slider/buffer.js";
import { SliderFill } from "../../../../../ui/slider/fill.js";
import { SliderPreview } from "../../../../../ui/slider/preview.js";
import { SliderThumb } from "../../../../../ui/slider/thumb.js";
import { ThumbnailImage } from "../../../../../ui/thumbnail/image.js";
import { SliderThumbnailRoot } from "../../../../../ui/slider/thumbnail/root.js";
import { SliderTrack } from "../../../../../ui/slider/track.js";
import { SliderValue } from "../../../../../ui/slider/value.js";
import { TimeSliderChapterTitle } from "../../../../../ui/time-slider/chapter-title.js";
import { TimeSliderChapters } from "../../../../../ui/time-slider/chapters.js";
import { TimeSliderRoot } from "../../../../../ui/time-slider/root.js";
import ForwardRef from "../../../../../icons/dist/react/minimal/spinner.js";
import { SliderBuffer as SliderBuffer$1, SliderFill as SliderFill$1, SliderThumb as SliderThumb$1, SliderTrack as SliderTrack$1 } from "../../../shared/components/sliders/slider.js";
import { jsx, jsxs } from "react/jsx-runtime";
import { cn, resolveClassName } from "@videojs/utils/style";
//#region src/internal/skins/minimal-video/components/sliders/time-slider.tsx
function TimeSlider({ className, previewOverflow = "visible", ...props } = {}) {
	return /* @__PURE__ */ jsxs(TimeSliderRoot, {
		className: (state) => cn("media-slider", "media-time-slider", resolveClassName(className, state)),
		...props,
		children: [
			/* @__PURE__ */ jsx(TimeSliderChapters, {
				className: "media-time-slider-chapters",
				renderChapter: (props) => /* @__PURE__ */ jsx("div", {
					className: "media-time-slider-chapter",
					...props,
					children: /* @__PURE__ */ jsxs(SliderTrack, {
						render: /* @__PURE__ */ jsx(SliderTrack$1, {}),
						className: "media-time-slider-chapter-track",
						children: [/* @__PURE__ */ jsx(SliderBuffer, { render: /* @__PURE__ */ jsx(SliderBuffer$1, {}) }), /* @__PURE__ */ jsx(SliderFill, { render: /* @__PURE__ */ jsx(SliderFill$1, {}) })]
					})
				})
			}),
			/* @__PURE__ */ jsx(SliderThumb, {
				render: /* @__PURE__ */ jsx(SliderThumb$1, {}),
				className: "media-time-slider-thumb"
			}),
			/* @__PURE__ */ jsxs(SliderPreview, {
				className: "media-slider-preview",
				overflow: previewOverflow,
				children: [/* @__PURE__ */ jsxs(SliderThumbnailRoot, {
					className: cn("media-slider-preview-content", "media-popup-surface", "media-slider-thumbnail"),
					children: [/* @__PURE__ */ jsx(ThumbnailImage, { className: "media-slider-thumbnail-image" }), /* @__PURE__ */ jsx(ForwardRef, { className: "media-slider-thumbnail-spinner-icon" })]
				}), /* @__PURE__ */ jsxs("div", {
					className: cn("media-slider-preview-content", "media-time-slider-preview-content"),
					children: [/* @__PURE__ */ jsx(TimeSliderChapterTitle, { className: "media-time-slider-chapter-title" }), /* @__PURE__ */ jsx(SliderValue, {
						className: "media-time-slider-value",
						type: "pointer"
					})]
				})]
			})
		]
	});
}
//#endregion
export { TimeSlider };

//# sourceMappingURL=time-slider.js.map